<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines " :inline="true">
                <el-form-item label="商品分类">
                    <el-select v-model="fl_value" placeholder="请选择" size="small" clearable  filterable >
                        <el-option v-for="item in fl_options" :key="item.id" :label="item.title" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品状态">
                    <el-select v-model="zt_value" placeholder="请选择" size="small"  clearable  filterable>
                        <el-option v-for="item in zt_options" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品品牌">
                    <el-select v-model="pp_value" placeholder="请选择" size="small"  clearable  filterable>
                        <el-option v-for="item in pp_options" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input size="small" v-model="title"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">添加
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
                <el-table-column prop="id" label="编号" width="80"> </el-table-column>
                <el-table-column prop="cat_name" label="分类名称" width="100"> </el-table-column>
                <el-table-column prop="favorites_id" label="封面" width="100"> </el-table-column>
                <el-table-column prop="title" label="名称"> </el-table-column>
                <el-table-column prop="sell_price" label="商品价格" width="100"> </el-table-column>
                <el-table-column prop="sort" label="排序" width="100"> </el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="160"> </el-table-column>
                <el-table-column  label="操作" width="100" > 
                     <template slot-scope="scope">
                         <el-dropdown @command="handleCommand">
                            <el-button type="primary" size="mini">
                                操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="beforeHandleCommand('1',scope.row)" >团购</el-dropdown-item>
                                <el-dropdown-item :command="beforeHandleCommand('2',scope.row)">秒杀</el-dropdown-item>
                                <el-dropdown-item :command="beforeHandleCommand('3',scope.row)">积分</el-dropdown-item>
                                <el-dropdown-item :command="beforeHandleCommand('4',scope.row)">编辑</el-dropdown-item>
                                <el-dropdown-item :command="beforeHandleCommand('5',scope.row)"><el-link type="danger">删除</el-link></el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                     </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog title="商品设置" :visible.sync="dialoged" top="80px" width="60%" center class="dialogs" @opened="handleOpen">
            <el-divider></el-divider>
                <div class="dialog-ibox-content">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="基本信息" name="1">
                            <basic ref="basics"></basic>
                        </el-tab-pane>
                        <el-tab-pane label="商品相册" name="2">
                            <album  ref="albums"></album>
                        </el-tab-pane>
                        <el-tab-pane label="商品描述" name="3">
                            <describe ref="describes"></describe>
                        </el-tab-pane>
                        <el-tab-pane label="商品规格" name="4">
                            <norms ref="norms"></norms>
                        </el-tab-pane>
                        <el-tab-pane label="商品属性" name="5">
                             <nature ref="natures"></nature>
                        </el-tab-pane>
                    </el-tabs>
                </div>
             <el-divider></el-divider>
        </el-dialog>

    </div>
</template>


<script>
    import { mapState} from 'vuex'
    import basic from '../../../components/shop/category/basic.vue'
    import album from '../../../components/shop/category/album.vue'
    import describe from '../../../components/shop/category/describe.vue'
    import norms from '../../../components/shop/category/norms.vue'
    import nature from '../../../components/shop/category/nature.vue'
    export default {
        components:{
            basic,
            album,
            describe,
            norms,
            nature
        },
        data() {
            return {
                loading: false,
                title:'',
                fl_value:'',
                fl_options:[],
                zt_value:'',
                zt_options:[{id:0,name:'上架'},{id:1,name:'下架'}],
                pp_value:'',
                pp_options:[],
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 20,
                height: null,
                gg_options:[],
                sx_options:[],
                // 
                dialoged:false,
                activeName:'1'
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.getxx()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 175 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 175 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 20
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios
                    .post("/admin/ShopGoods/index", {
                        page: that.currentPage,
                        limit: that.pagesize,
                        cat_id:that.fl_value,
                        status:that.zt_value,
                        brand_id:that.pp_value,
                        title:that.title
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.total
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd() {
                this.dialoged=true
               
            },
            handleOpen(){
                this.$nextTick(()=>{
                    this.$refs.basics.pp_options=this.pp_options
                    this.$refs.basics.fl_options=this.fl_options
                    this.$refs.norms.fl_options=this.gg_options
                    this.$refs.natures.mx_options=this.sx_options
                })
            },
            handleClick(){

            },
            handleCommand(command) {
                if(command.command==1){
                    
                }
                if(command.command==5){
                    this.handleDelete(command.row)
                }
                
            },
            beforeHandleCommand(item,row){
                return {
                    'command': item,
                    'row': row
                }
            },
            handleDelete(row) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/ShopGoods/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            getxx(){
                 axios
                    .post("/admin/ShopGoods/getCatBrand", {}, {
                        token: true
                    })
                    .then(response => {
                        this.fl_options=response.data.data.cat
                        this.pp_options=response.data.data.brand
                        this.gg_options=response.data.data.attribute
                        this.sx_options=response.data.data.model
                        
                        
                    })
                    .catch(error => {})
            }
        },

    };
</script>


<style scoped>
</style>